import { RatingsIntervalType, RatingsRatingType, formatRatingsApiDate, getYesterdayDate } from 'shared/pages/Ratings/const';

export enum ShowcaseFilterType {
    likes = 0,
    views = 1,
}

export const showcaseFilterToRatingType: Record<ShowcaseFilterType, RatingsRatingType> = {
    [ShowcaseFilterType.likes]: RatingsRatingType.likes,
    [ShowcaseFilterType.views]: RatingsRatingType.views,
};

export interface IShowcaseRatingsFilter {
    ratingType: ShowcaseFilterType;
    date: string | null;
    intervalType?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    monthValue?: string | null;
}

export const initialRatingsFilter: IShowcaseRatingsFilter = (() => {
    const yesterday = getYesterdayDate();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.day,
        date: formatRatingsApiDate(yesterday),
        dateFrom: yesterday.toISOString(),
        dateTo: yesterday.toISOString(),
        monthValue: null,
    };
})();import { RatingsIntervalType, RatingsRatingType, formatRatingsApiDate, getYesterdayDate } from 'shared/pages/Ratings/const';

export enum ShowcaseFilterType {
    likes = 0,
    views = 1,
}

export const showcaseFilterToRatingType: Record<ShowcaseFilterType, RatingsRatingType> = {
    [ShowcaseFilterType.likes]: RatingsRatingType.likes,
    [ShowcaseFilterType.views]: RatingsRatingType.views,
};

export interface IShowcaseRatingsFilter {
    ratingType: ShowcaseFilterType;
    date: string | null;
    intervalType?: number | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    monthValue?: string | null;
}

export const initialRatingsFilter: IShowcaseRatingsFilter = (() => {
    const yesterday = getYesterdayDate();
    return {
        ratingType: ShowcaseFilterType.views,
        intervalType: RatingsIntervalType.day,
        date: formatRatingsApiDate(yesterday),
        dateFrom: yesterday.toISOString(),
        dateTo: yesterday.toISOString(),
        monthValue: null,
    };
})();